const Footer = () => {
  return (
      <footer className="bg-light bg-pink-200 mt-auto">
      <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-md-6 text-center text-md-start">
              <p className="mb-0 fw-bold small">
                &copy; 2024 Centro Estética Antonia. Todos los derechos reservados.
              </p>
            </div>
            <div className="col-md-6 text-center text-md-end">
              <span className="fw-bold small me-2">Nuestras Redes Sociales:</span>
              <a
                  className="p-1"
                  href="https://wa.me//?text=Hola, Buenas"
                  target="_blank"
                  rel="noopener noreferrer"
              >
                <img src="/static/img/whatsapp.png" alt="Whatsapp" width="30" draggable="false" />
              </a>
              <a
                  className="p-1"
                  href="https://www.instagram.com/antonia.estetica.calama_/"
                  target="_blank"
                  rel="noopener noreferrer"
              >
                <img src="/static/img/instagram.png" alt="Instagram" width="30" draggable="false" />
              </a>
            </div>
          </div>
        </div>
      </footer>
  );
};


export default Footer;
